module.exports = __webpack_public_path__ + "static/img/103897.763d59d6.png";